import { render, staticRenderFns } from "./His.vue?vue&type=template&id=778f505a&scoped=true&"
import script from "./His.vue?vue&type=script&lang=js&"
export * from "./His.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f505a",
  null
  
)

export default component.exports